// Mock data for MBhost landing page

export const mockWaitlistSubmit = async (email, name) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock waitlist submission:', { email, name });
      resolve({ success: true, message: 'Successfully joined the waitlist!' });
    }, 1000);
  });
};

export const features = [
  {
    id: 1,
    title: 'One-Click Deployments',
    description: 'Deploy web apps, APIs, or databases instantly using pre-configured templates. No complex setup required.',
    icon: 'Zap',
    image: 'https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d'
  },
  {
    id: 2,
    title: 'Localized Infrastructure',
    description: 'Indian data centers for better latency, security, and compliance. Built for the Indian ecosystem.',
    icon: 'MapPin',
    image: 'https://images.unsplash.com/photo-1667984390535-6d03cff0b11a'
  },
  {
    id: 3,
    title: 'Real-Time Monitoring',
    description: 'Track your infrastructure with intuitive dashboards and get instant insights into performance metrics.',
    icon: 'Activity',
    image: 'https://images.unsplash.com/photo-1667984550708-a6beba23cb4c'
  },
  {
    id: 4,
    title: 'Managed Databases',
    description: 'Fully managed database hosting with automatic backups, scaling, and 99.99% uptime guarantee.',
    icon: 'Database',
    image: 'https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg'
  },
  {
    id: 5,
    title: 'Security Built-In',
    description: 'Enterprise-grade security with firewalls, DDoS protection, and data encryption out of the box.',
    icon: 'Shield'
  },
  {
    id: 6,
    title: 'Developer-First Tools',
    description: 'Integrated Git workflows, REST APIs, and CLI tools designed for modern development workflows.',
    icon: 'Code'
  }
];

export const useCases = [
  {
    id: 1,
    title: 'Web Applications',
    description: 'Deploy and scale your web apps with zero configuration. From MVPs to production-grade applications.',
    icon: 'Globe'
  },
  {
    id: 2,
    title: 'API Services',
    description: 'Host high-performance REST and GraphQL APIs with automatic SSL and load balancing.',
    icon: 'Layers'
  },
  {
    id: 3,
    title: 'Database Hosting',
    description: 'Managed PostgreSQL, MongoDB, and Redis with automated backups and point-in-time recovery.',
    icon: 'Database'
  },
  {
    id: 4,
    title: 'Microservices',
    description: 'Deploy containerized microservices with Kubernetes orchestration and service mesh.',
    icon: 'Box'
  }
];

export const techStack = [
  { name: 'Docker', category: 'Container' },
  { name: 'Kubernetes', category: 'Orchestration' },
  { name: 'PostgreSQL', category: 'Database' },
  { name: 'MongoDB', category: 'Database' },
  { name: 'Redis', category: 'Cache' },
  { name: 'Nginx', category: 'Web Server' }
];

export const metrics = [
  { value: '500+', label: 'Active Users', icon: 'Users' },
  { value: '10K+', label: 'Deployments', icon: 'Rocket' },
  { value: '99.99%', label: 'Uptime', icon: 'TrendingUp' },
  { value: '24/7', label: 'Support', icon: 'MessageCircle' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Rahul Sharma',
    role: 'CTO, TechStart India',
    company: 'TechStart',
    content: 'MBhost has transformed how we deploy and manage our infrastructure. The simplicity combined with enterprise features is exactly what Indian startups need.',
    rating: 5
  },
  {
    id: 2,
    name: 'Priya Patel',
    role: 'Founder, CloudCraft',
    company: 'CloudCraft',
    content: 'Finally, a cloud platform that understands the Indian market. Low latency, transparent pricing, and excellent support make MBhost our go-to choice.',
    rating: 5
  },
  {
    id: 3,
    name: 'Amit Kumar',
    role: 'Lead Developer, DevHub',
    company: 'DevHub',
    content: 'The developer experience is outstanding. From CLI tools to API integrations, everything just works. Plus, the cost savings compared to AWS are significant.',
    rating: 5
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: 'Developer',
    price: '499',
    period: 'month',
    description: 'Perfect for individual developers and side projects',
    features: [
      '2 vCPU cores',
      '4 GB RAM',
      '80 GB SSD Storage',
      '2 TB Bandwidth',
      'Basic Support',
      '1 Free Domain'
    ],
    highlighted: false
  },
  {
    id: 2,
    name: 'Startup',
    price: '1,999',
    period: 'month',
    description: 'For growing startups and small teams',
    features: [
      '4 vCPU cores',
      '16 GB RAM',
      '200 GB SSD Storage',
      '5 TB Bandwidth',
      'Priority Support',
      '3 Free Domains',
      'Managed Databases',
      'Auto-scaling'
    ],
    highlighted: true
  },
  {
    id: 3,
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'Custom infrastructure for large-scale applications',
    features: [
      'Custom vCPU cores',
      'Custom RAM',
      'Custom Storage',
      'Unlimited Bandwidth',
      '24/7 Dedicated Support',
      'Unlimited Domains',
      'Advanced Security',
      'Custom SLA'
    ],
    highlighted: false
  }
];

export const roadmapItems = [
  {
    id: 1,
    quarter: 'Q4 2025',
    title: 'MVP Launch',
    description: 'Compute + Storage + Control Panel',
    status: 'current'
  },
  {
    id: 2,
    quarter: 'Q1 2026',
    title: 'Enhanced Features',
    description: 'Managed Databases + API Deployments',
    status: 'upcoming'
  },
  {
    id: 3,
    quarter: 'Q2 2026',
    title: 'Marketplace Launch',
    description: 'App Marketplace + Analytics Dashboard',
    status: 'upcoming'
  },
  {
    id: 4,
    quarter: 'Q3 2026',
    title: 'Global Expansion',
    description: 'SEA Data Centers',
    status: 'upcoming'
  },
  {
    id: 5,
    quarter: '2027+',
    title: 'AI-Powered',
    description: 'Autoscaling + Predictive Infrastructure',
    status: 'future'
  }
];

export const comparisonData = [
  {
    feature: 'Pricing Model',
    mbhost: 'Flat subscription',
    others: 'Pay-as-you-go (unpredictable)'
  },
  {
    feature: 'Setup Time',
    mbhost: 'One-click deployment',
    others: 'Complex configuration'
  },
  {
    feature: 'Data Centers',
    mbhost: 'Indian metros (low latency)',
    others: 'Global (high latency for India)'
  },
  {
    feature: 'Support',
    mbhost: '24/7 developer support',
    others: 'Limited support for small teams'
  },
  {
    feature: 'Learning Curve',
    mbhost: 'Simple & intuitive',
    others: 'Requires certified engineers'
  }
];